module.exports = __webpack_public_path__ + "img/PS21.b4862152.png";